import { Illustration, type IllustrationType, Text } from "@clipboard-health/ui-components";
import { Stack } from "@mui/material";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib";
import { logEvent } from "@src/appV2/lib/analytics";
import { useLogEffect } from "@src/appV2/lib/analytics/useLogEffect";
import { Button } from "@src/appV2/redesign/components/Button";
import { DialogFooter } from "@src/appV2/redesign/components/DialogFooter";
import { type PlacementCandidate } from "@src/appV2/redesign/PlacementCandidate/types";
import { type InterviewWithDetails } from "@src/appV2/redesign/WorkerShifts/api/useFetchPaginatedInterviews";

import { type FeedbackStep } from "./feedbackStep";
import { useInterviewAttendanceSource } from "./useInterviewAttendanceSource";

interface InterviewAttendanceConfirmationDialogProps {
  title: string;
  description: string;
  illustration?: IllustrationType;
  ctaText: string;
  ctaOnClick: () => void;
  step?: FeedbackStep;
  placementCandidate: PlacementCandidate;
  interview?: InterviewWithDetails;
}

export function InterviewAttendanceConfirmationContent(
  props: InterviewAttendanceConfirmationDialogProps
) {
  const {
    title,
    description,
    illustration,
    ctaOnClick,
    ctaText,
    placementCandidate,
    step,
    interview,
  } = props;

  const source = useInterviewAttendanceSource();

  const eventContext = {
    step,
    placementCandidate,
    interview,
    source,
  };
  useLogEffect(APP_V2_APP_EVENTS.PLACEMENT_INTERVIEW_ATTENDANCE_CONFIRMATION_VIEWED, eventContext);

  return (
    <>
      <Stack
        spacing={8}
        alignItems="center"
        justifyContent="center"
        sx={{ paddingX: 8, paddingY: 6 }}
      >
        {illustration ? <Illustration type={illustration} /> : undefined}
        <Stack spacing={6} textAlign="center">
          <Text variant="h2">{title}</Text>
          <Text>{description}</Text>
        </Stack>
      </Stack>
      <DialogFooter orientation="horizontal" sx={{ px: 8, pb: 8, pt: 2 }}>
        <Stack spacing={4} width="100%">
          <Button
            variant="contained"
            size="large"
            onClick={() => {
              logEvent(
                APP_V2_APP_EVENTS.PLACEMENT_INTERVIEW_ATTENDANCE_CONFIRMATION_CTA_CLICKED,
                eventContext
              );
              ctaOnClick();
            }}
          >
            {ctaText}
          </Button>
        </Stack>
      </DialogFooter>
    </>
  );
}
